"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNavigationPath = void 0;
function getNavigationPath(root, targetSlug) {
    var _a;
    if (!targetSlug) {
        return [];
    }
    for (let child of (_a = root.children) !== null && _a !== void 0 ? _a : []) {
        if (child) {
            const path = getNavigationPathFromLink(child, targetSlug);
            if (path) {
                return path;
            }
        }
    }
    return [];
}
exports.getNavigationPath = getNavigationPath;
function getNavigationPathFromLink(root, targetSlug) {
    var _a, _b, _c;
    if (((_b = (_a = root.target) === null || _a === void 0 ? void 0 : _a.slug) === null || _b === void 0 ? void 0 : _b.current) === targetSlug) {
        return [root];
    }
    for (let child of (_c = root.children) !== null && _c !== void 0 ? _c : []) {
        if (child) {
            const path = getNavigationPathFromLink(child, targetSlug);
            if (path) {
                return [root, ...path];
            }
        }
    }
    return null;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmF2aWdhdGlvblV0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvaGVscC9zYW5pdHkvbmF2aWdhdGlvblV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUtBLFNBQWdCLGlCQUFpQixDQUMvQixJQUF3QixFQUN4QixVQUFxQzs7SUFFckMsSUFBSSxDQUFDLFVBQVUsRUFBRTtRQUNmLE9BQU8sRUFBRSxDQUFDO0tBQ1g7SUFDRCxLQUFLLElBQUksS0FBSyxJQUFJLE1BQUEsSUFBSSxDQUFDLFFBQVEsbUNBQUksRUFBRSxFQUFFO1FBQ3JDLElBQUksS0FBSyxFQUFFO1lBQ1QsTUFBTSxJQUFJLEdBQUcseUJBQXlCLENBQUMsS0FBSyxFQUFFLFVBQVUsQ0FBQyxDQUFDO1lBQzFELElBQUksSUFBSSxFQUFFO2dCQUNSLE9BQU8sSUFBSSxDQUFDO2FBQ2I7U0FDRjtLQUNGO0lBQ0QsT0FBTyxFQUFFLENBQUM7QUFDWixDQUFDO0FBaEJELDhDQWdCQztBQUVELFNBQVMseUJBQXlCLENBQ2hDLElBQTRCLEVBQzVCLFVBQWtCOztJQUVsQixJQUFJLENBQUEsTUFBQSxNQUFBLElBQUksQ0FBQyxNQUFNLDBDQUFFLElBQUksMENBQUUsT0FBTyxNQUFLLFVBQVUsRUFBRTtRQUM3QyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7S0FDZjtJQUNELEtBQUssSUFBSSxLQUFLLElBQUksTUFBQSxJQUFJLENBQUMsUUFBUSxtQ0FBSSxFQUFFLEVBQUU7UUFDckMsSUFBSSxLQUFLLEVBQUU7WUFDVCxNQUFNLElBQUksR0FBRyx5QkFBeUIsQ0FBQyxLQUFLLEVBQUUsVUFBVSxDQUFDLENBQUM7WUFDMUQsSUFBSSxJQUFJLEVBQUU7Z0JBQ1IsT0FBTyxDQUFDLElBQUksRUFBRSxHQUFHLElBQUksQ0FBQyxDQUFDO2FBQ3hCO1NBQ0Y7S0FDRjtJQUNELE9BQU8sSUFBSSxDQUFDO0FBQ2QsQ0FBQyJ9